<div class="left-side">
  <div class="text-column">
    <p class="tag">{{ 'onboarding.stepOne.tag' | translate }}</p>
    <p class="title">{{ welcomeMessage() }}</p>

    @if (communityName()) {
      <p class="lead">
        {{ 'onboarding.stepOne.communityPrefix' | translate }} <strong>{{ communityName() }}</strong
        >.
      </p>
    }

    <div class="cards">
      <app-onboarding-info-card badgeColor="pink">
        <actee-icon
          slot="badge"
          name="star-fill"
        />
        <span slot="title">{{ 'onboarding.stepOne.cards.newPlatform.title' | translate }}</span>
        <span slot="description">{{ 'onboarding.stepOne.cards.newPlatform.description' | translate }}</span>
      </app-onboarding-info-card>
      <app-onboarding-info-card badgeColor="purple">
        <actee-icon
          slot="badge"
          name="documents"
        />
        <span slot="title">{{ 'onboarding.stepOne.cards.manageRequests.title' | translate }}</span>
        <span slot="description">{{ 'onboarding.stepOne.cards.manageRequests.description' | translate }}</span>
      </app-onboarding-info-card>
    </div>
  </div>
</div>
<div class="right-side">
  <img
    ngSrc="/images/onboarding/step-1.svg"
    width="470"
    height="408"
    priority
    [alt]="'onboarding.stepOne.imageAlt' | translate"
  />
</div>
